import { render, staticRenderFns } from "./OdontogramPatterns.vue?vue&type=template&id=b4fd1f38&"
import script from "./OdontogramPatterns.vue?vue&type=script&lang=ts&"
export * from "./OdontogramPatterns.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports